<div class="canvas">
    <p>
        Version 1.4.2
        <br>
        Angular {{this.version.full}}
    </p>
</div>

